export const splitEmomItemLoad = (load) => {
	const normalized = String(load || "").trim();
	if (!normalized) return { load_male: "", load_female: "" };

	const separatorIndex = normalized.indexOf("/");
	if (separatorIndex < 0) {
		return { load_male: normalized, load_female: "" };
	}

	return {
		load_male: normalized.slice(0, separatorIndex).trim(),
		load_female: normalized.slice(separatorIndex + 1).trim(),
	};
};

export const joinEmomItemLoads = (loadMale, loadFemale) => {
	const male = String(loadMale || "").trim();
	const female = String(loadFemale || "").trim();
	if (male && female) return `${male}/${female}`;
	return male || female;
};
